import {
  SELECT_SITE,
  RESET_SITE,
  SELECT_TAB,
  SELECT_SECTION,
  SET_INITIALIZED,
} from "../../constants/actionTypes";

export const selectSite = (name, data) => ({
  type: SELECT_SITE,
  name,
  payload: data,
});

export const resetSite = (name) => ({
  type: RESET_SITE,
  name,
});

export const selectTab = (name, tab, section = "main") => {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_TAB,
      name,
      tab,
    });
    dispatch({
      type: SELECT_SECTION,
      name,
      section,
    });
  };
};

export const setInitialized = (name, payload) => ({
  type: SET_INITIALIZED,
  name,
  payload,
});
